/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  'use strict';

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages
        $('#wrapper').wrapper();
        $('#sectionTestimonial').sectionTestimonial();
        $('#sectionCourses').sectionCourses();
        $('#sectionPhotos').sectionPhotos();
        $('#aboutGallery').aboutGallery();
        $('.courseInformationStrip').courseInformationStrip();
        $('.productDetailPriceContainer.pinned').productDetailPriceContainer();
        $('#backToTopButton').backToTopButton();
        $('*[data-scroll-to-object]').scrollToObject();
        $('#coursesBanner').internalHeader();
        $('#productBanner').productBanner();
        $('#aboutBanner').aboutBanner();
        $('#trackRecords').trackRecords();
        $('#clientesFlip').clientesFlip();
        $('#homeBanner').homeBanner();
        $('#homeIntro').homeIntro();
        $('#homeClients').homeClients();
        $('#genericBanner').genericBanner();
        $('#homeBlog').homeBlog();
        $('#contactMap').contactMap();
        $('#postsCategories').postsCategories();
        $('#productVideo').productVideo();
        $('#productSolution').productSolution();
        $('#productFunctions').productFunctions();
        $('#productGallery').productGallery();
        $('#blogBannerBrand').blogBannerBrand();
        $('.mainHeader').mainHeader();
        $('.questionHeader').questionHeader();
        $('.essb_displayed_sidebar').socialSidebar();
        $('#blogBanner').blogBanner();
        $('#testimonialsContainer').testimonialsContainer();
        $('#blogBannerItem').blogBannerItem();
        $('#mainSidebar').mainSidebar();
        $('#mainSection .entry-content .entry-content-wrapper').blogPostContent();
        $('[data-toggle="popover"]').popover({ container: 'body' });
        $('[data-toggle="tooltip"]').tooltip({ container: 'body' });
        $('[data-hover="dropdown"]').dropdownHover();
        $('.verticalMenu').verticalMenu();
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'codigo_de_etica_e_conduta': {
      init: function() {
        $('.cc-item a').click(function () {
          $('.cc-item.selected').removeClass('selected');
          $(this).parent().addClass('selected');
        });
      },
      finalize: function() {
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };


  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

// wrapper
(function ($) {

  'use strict';

  $.fn.wrapper = function () {

    // protection
    if (!this.length) { return; }
    //

    var wrapper = $(this);
    var toggle = $('#wrapper-sidebar-toggle');
    var content = $('#wrapper-content');
    var sidebar = $('#wrapper-sidebar');
    var overlay = $('#wrapper-overlay');
    var animating = false;
    var open = false;
    var speed = 0.5;
    var ease = Power2.easeOut;
    var tl;

    $(window).resize(onResize);
    onResize();

    function onResize() {
      /*wrapper.removeClass('open');

      if($(window).width() <= 350) {toggle.addClass('smallScreen');}
      else {toggle.removeClass('smallScreen');}*/
      toggleState(false);
    }

    toggle.click(function (e) {
      e.preventDefault();
      toggleState(!open);
    });

    overlay.click(function (e) {
      e.preventDefault();
      toggleState(false);
    });

    function toggleState(bol) {
      if (animating) { return; }
      open = bol;

      if (open) { wrapper.addClass('open'); }
      else { wrapper.removeClass('open'); }

      // -------------

      var w = sidebar.width();

      if (open) {
        tl = new TimelineMax({ onComplete: onComplete });
        tl.fromTo(wrapper, speed, { left: 0 }, { left: w, ease: ease }, '-=' + speed);
        tl.fromTo(overlay, speed, { autoAlpha: 0 }, { autoAlpha: 0.8, ease: ease }, '-=' + speed);
        tl.fromTo(content, speed, { marginLeft: 0 }, { marginLeft: -w, ease: ease }, '-=' + speed);
        tl.fromTo(sidebar, speed, { right: -w }, { right: 0, ease: ease }, '-=' + speed);
      } else {
        tl = new TimelineMax({ onComplete: onComplete });
        tl.to(wrapper, speed, { left: 0, ease: ease }, '-=' + speed);
        tl.to(overlay, speed, { autoAlpha: 0, ease: ease }, '-=' + speed);
        tl.to(content, speed, { marginLeft: 0, ease: ease }, '-=' + speed);
        tl.to(sidebar, speed, { right: -w, ease: ease }, '-=' + speed);
      }
    }

    function onComplete() {
      animating = false;
    }

  };
}(jQuery));

// verticalMenu
(function ($) {
  /*jshint validthis:true */

  'use strict';

  $.fn.verticalMenu = function () {

    return this.each(function () {

      var verticalMenu = $(this);
      var sidebarMenuSearch = $('.sidebarMenuSearch');
      var lists = verticalMenu.find('ul');
      var mainList = verticalMenu.find('> ul');
      var listItems = verticalMenu.find('li');
      var listItemsAnchor = listItems.find('> a');
      var nowActiveMenu;
      var fixedHeight = verticalMenu.hasClass('fixedHeight');
      var level = 0;
      var animSpeed = 0.5;
      var animEase = Expo.easeOut;//Expo.easeInOut;
      var animating = false;

      fixLIs();
      fixULs();

      var categoryParents = verticalMenu.find('.categoryParent');

      listItemsAnchor.click(itemClick);
      categoryParents.click(categoryParentClick);

      $(window).resize(function () {
        mainList.css('left', menuPos());
      });

      function categoryParentClick(event) {
        event.preventDefault();
        if (animating) { return; }

        var a = $(this);
        var ul = a.parent().parent().parent();
        nowActiveMenu = ul;
        animStart();

        var tl = new TimelineLite({ onComplete: animFinish });
        tl.to(mainList, animSpeed, { left: menuPos(), ease: animEase });
        tl.set(a.parent(), { display: 'none' });

        sidebarMenuSearch.show();
      }

      function menuPos() {
        return -verticalMenu.width() * level;
      }

      function itemClick(event) {
        var a = $(this);
        var li = a.parent();
        var ul = li.find('> ul');
        var lists = li.parent().find('li ul');

        var hasInsideList = Boolean(ul.length);

        if (hasInsideList) {
          if (animating) { return; }
          event.preventDefault();
          nowActiveMenu = ul;
          animStart();

          TweenLite.set(lists, { display: 'none' });
          TweenLite.set(ul, { display: 'block' });
          if (fixedHeight) { TweenLite.set(li.parent(), { overflowY: 'visible' }); }

          var tl = new TimelineLite({ onComplete: animFinish });
          tl.to(mainList, animSpeed, { left: menuPos(), ease: animEase });
        }
      }

      function animStart() {
        var nowActiveMenuHeight = nowActiveMenu.height();
        $(verticalMenu).scrollTop(0);

        animating = true;

        level = nowActiveMenu.parentsUntil('.verticalMenu', 'ul').length;

        if (fixedHeight) {
          TweenLite.to(verticalMenu, 0.5, { height: nowActiveMenuHeight, ease: Expo.easeOut });
        }
      }

      function animFinish() {
        //if(!fixedHeight) {$(verticalMenu).perfectScrollbar('update');}
        animating = false;
      }

      function fixLIs() {
        $.each(listItems, function () {
          var hasList = Boolean($(this).has('ul').length);

          if (hasList) {
            $(this).find('> a').prepend('<i class="fa fa-chevron-right"></i>');
          }
        });
      }

      function fixULs() {

        var menuHeight = 0;

        $.each(lists, function (index) {

          // is main list, don't do anything
          if (index === 0) {
            nowActiveMenu = $(this);
            menuHeight = $(this).height();
            if (fixedHeight) {
              verticalMenu.height(menuHeight);
            } else {
              //$(verticalMenu).perfectScrollbar({ suppressScrollX: true });
            }
          } else {

            var ul = $(this);
            var listItemParent = ul.parent();
            var listItemParentAnchor = listItemParent.find('> a');
            var listItemParentAnchorText = listItemParentAnchor.find('span');
            var text = listItemParentAnchorText.text();

            text = 'Voltar';

            //$(ul).perfectScrollbar({ suppressScrollX: true });
            //ul.height(menuHeight);
            ul.prepend('<a href="#" class="categoryParent"><i class="fa fa-chevron-left"></i><span>' + text + '</span></a>');
          }

        });
      }
    });

  };
}(jQuery));

// blogPostContent
(function ($) {

  'use strict';

  $.fn.blogPostContent = function () {

    // protection
    if (!this.length) { return; }
    //

    //var blogPostContent = $(this);
    /*blogPostContent.readmore({
      moreLink: '<a href="#" class="read-more-button btn btn-primary btn-block">CONTINUAR LENDO</a>',
      lessLink: '',
      collapsedHeight: 500
    });*/

  };
}(jQuery));

// blogBanner
(function ($) {
  /*jshint validthis:true */

  'use strict';

  $.fn.blogBanner = function () {

    var blogBanner = $(this);
    var items = blogBanner.find('.item');
    var onlyItem = items.length === 1;
    var carousel = blogBanner.find('.carousel').flickity({
      percentPosition: false,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      dragThreshold: 10,
      draggable: onlyItem ? false : true,
      pageDots: onlyItem ? false : true
    });
    var bg = carousel.find('.bg');
    var textContainer = carousel.find('.textContainer');
    var flkty = carousel.data('flickity');

    carousel.on('scroll.flickity', function () {
      var title;

      if ($.isXs() || $.isSm()) {
        title = carousel.find('.entry-title');
        TweenLite.set(title, { clearProps: 'all' });
      } else {
        // só funciona na versão desktop
        flkty.slides.forEach(function (slide, i) {
          title = items.eq(i).find('.entry-title');
          var x = (slide.target + flkty.x) * -1 / 5;
          TweenLite.set(title, { x: x });
        });
      }
    });

    TweenMax.set(textContainer, { opacity: 1 });

    //-------------------------------------------------------

    var scene, tween, controller;

    /*$(window).on('scroll resize', function(){
      owl.trigger('stop.owl.autoplay');
      owl.trigger('play.owl.autoplay');
    });*/

    $(window).resize(onResize);
    onResize();

    function onResize() {
      if ($.isXs() || $.isSm()) {
        removeAnim();
      } else {
        initAnim();
      }
    }

    function initAnim() {
      removeAnim();

      if (!shouldParallax()) { return; }

      controller = new ScrollMagic.Controller();

      tween = new TimelineMax().add([
        TweenMax.to(bg, 1, { y: $(window).height() / 2, ease: Linear.easeNone })
      ]);

      scene = new ScrollMagic.Scene({ duration: $(window).height() }).setTween(tween).addTo(controller);
    }

    function removeAnim() {
      if (controller) {
        controller.destroy(true);
        controller = null;
      }
    }
  };
}(jQuery));

// testimonialsContainer
(function ($) {
  /*jshint validthis:true */

  'use strict';

  $.fn.testimonialsContainer = function () {

    var testimonialsContainer = $(this);
    var items = testimonialsContainer.find('.item');
    var onlyItem = items.length === 1;
    var carousel = testimonialsContainer.find('.carousel').flickity({
      percentPosition: false,
      resize: true,
      wrapAround: true,
      prevNextButtons: onlyItem ? false : true,
      dragThreshold: 10,
      draggable: onlyItem ? false : true,
      pageDots: onlyItem ? false : true
    });
    var textContainer = carousel.find('.textContainer');
    var flkty = carousel.data('flickity');

    carousel.on('scroll.flickity', function () {
      var title;

      if ($.isXs() || $.isSm()) {
        title = carousel.find('.entry-title');
        TweenLite.set(title, { clearProps: 'all' });
      } else {
        // só funciona na versão desktop
        flkty.slides.forEach(function (slide, i) {
          title = items.eq(i).find('.entry-title');
          var x = (slide.target + flkty.x) * -1 / 5;
          TweenLite.set(title, { x: x });
        });
      }
    });

    TweenMax.set(textContainer, { opacity: 1 });
  };
}(jQuery));

// internalHeader
(function ($) {

  'use strict';

  $.fn.internalHeader = function () {

    // protection
    if (!this.length) { return; }
    //

    var internalHeader = $(this);
    var bg = internalHeader.find('.bg');
    var textContainer = internalHeader.find('.textContainer');
    var icon = textContainer.find('img');
    var title = textContainer.find('h1');
    var scene;

    var tl = new TimelineLite({ delay: 1 });
    tl.fromTo(icon, 1, { scale: 0 }, { scale: 1, opacity: 1, ease: Expo.easeOut });
    tl.fromTo(title, 1, { y: '+=100' }, { y: '-=100', opacity: 1, ease: Expo.easeOut }, '-=.5');

    var tween = new TimelineMax().add([
      TweenMax.to(bg, 1, { y: $(window).height() / 2, ease: Linear.easeNone })
    ]);

    scene = new ScrollMagic.Scene({ duration: $(window).height() }).setTween(tween).addTo(new ScrollMagic.Controller());

  };
}(jQuery));

// backgroundVideo
(function ($) {

  'use strict';

  $.fn.backgroundVideo = function () {

    // protection
    if (!this.length) { return; }
    //

    var backgroundVideo = $(this);

    var video = backgroundVideo.find('video').get(0);
    var container = backgroundVideo.get(0);

    if (isMobile()) {
      // is mobile
      $(video).remove();
    } else {
      // not mobile
      video.addEventListener('loadedmetadata', onResize, false);
      video.addEventListener('play', onResize, false);

      $(window).resize(onResize);
      onResize();

    }

    function onResize() {
      fit(video, container, { cover: true, watch: false });
    }

  };
}(jQuery));

// homeIntro
(function ($) {

  'use strict';

  $.fn.homeIntro = function () {

    // protection
    if (!this.length) { return; }
    //

    var homeIntro = $(this);

    var carousel = homeIntro.find('.carousel');

    carousel.flickity({
      watchCSS: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true
    });

  };
}(jQuery));

// homeClients
(function ($) {

  'use strict';

  $.fn.homeClients = function () {

    // protection
    if (!this.length) { return; }
    //

    var homeClients = $(this);
    var carousel = homeClients.find('.carousel');

    carousel.flickity({
      watchCSS: true,
      wrapAround: true,
      prevNextButtons: false,
      cellAlign: 'left',
      groupCells: true,
      pageDots: true
    });

  };
}(jQuery));

// mainHeader
(function ($) {

  'use strict';

  $.fn.mainHeader = function () {

    // protection
    if (!this.length) { return; }
    //

    var mainHeader = $(this);
    var headerTitle = $('#headerTitle');
    var headerTitleText = headerTitle.find('.title');
    var badge = mainHeader.find('.badge.animate');
    mainHeader.css('display', 'block');

    $(window).resize(onScroll);
    $(window).scroll(onScroll);
    onScroll();
    animateBadges();
    mainHeader.addClass('transition');

    function animateBadges() {
      TweenMax.set(badge, { opacity: 1 });
      TweenMax.from(badge, 0.5, { delay: 3, scale: 0, ease: Back.easeOut });

      /*var distance = 15;
      var tl = new TimelineMax({repeat:-1, repeatDelay:1});
      tl.to(badge, 0.2, {y:'-=' + distance, ease:Power2.easeOut});
      tl.to(badge, 0.4, {y:'+=' + distance, ease:Bounce.easeOut});*/
    }

    function onScroll() {

      if ($(mainHeader).css('position') === 'fixed') {
        // Só funciona se o position for fixed

        if ($(window).scrollTop() === 0) {
          mainHeader.addClass('onTop');
        } else {
          mainHeader.removeClass('onTop');
        }
      } else {
        mainHeader.addClass('onTop');
      }
      // ------------ headerTitle

      var size = $(window).height() * 0.5;
      if ($('body').hasClass('codigo-de-etica-e-conduta')) {
        size = 240;
      }

      if ($(window).scrollTop() < size / 2) {
        TweenMax.set(headerTitleText, { y: 80, autoAlpha: 0 });
      } else if ($(window).scrollTop() < size) {
        TweenMax.to(headerTitleText, 0.5, { y: 80, autoAlpha: 0, ease: Power2.easeOut });
      } else {
        TweenMax.to(headerTitleText, 0.5, { y: 0, autoAlpha: 1, ease: Power2.easeOut });
      }

      if($(window).scrollTop() < size) {
        $('.cc-main-menu').removeClass('fixed');
        $('.cc-content').removeClass('fixed');
      } else {
        $('.cc-main-menu').addClass('fixed');
        $('.cc-content').addClass('fixed');
      }

      changeHeaderTitleWidth();
    }

    function changeHeaderTitleWidth() {
      if (headerTitle.length === 0) { return; }

      TweenMax.set(headerTitleText, { clearProps: 'width' });

      var titleLeft = headerTitleText.offset().left;
      var titleWidth = headerTitleText.width();
      var menuWidth = $(window).width() - getMenuSize();
      var isSmaller = titleLeft + titleWidth < menuWidth;
      var diff = titleLeft + titleWidth - menuWidth;

      if (isSmaller) {
        // se for menor não preciso aplicar o fade no final
        headerTitle.removeClass('titleSmall');
      } else {
        headerTitle.addClass('titleSmall');
        TweenMax.set(headerTitleText, { width: headerTitleText.width() - diff });
      }
    }

    function getMenuSize() {
      var w = 470;

      if ($.isXs() || $.isSm()) {
        w = 200;
      }

      return w;
    }
  };
}(jQuery));

// questionHeader
(function ($) {

  'use strict';

  $.fn.questionHeader = function () {

    // protection
    if (!this.length) { return; }
    //

    var questionHeader = $(this);
    var blogBannerItem = $('#blogBannerItem');
    //questionHeader.css('display', 'block');

    $(window).scroll(onScroll);
    onScroll();

    function onScroll() {

      var topGap;

      if ($.isXs() || $.isSm()) {
        // mobile version without header
        topGap = 0;
      }
      else {
        topGap = $('.mainHeader').outerHeight();
      }

      if ($(window).scrollTop() < blogBannerItem.height() - topGap) {
        questionHeader.removeClass('fixed');
      } else {
        questionHeader.addClass('fixed');
      }
    }

  };
}(jQuery));

// blogBannerBrand
(function ($) {

  'use strict';

  $.fn.blogBannerBrand = function () {

    // protection
    if (!this.length) { return; }
    //

    var blogBannerBrand = $(this);
    var bg = blogBannerBrand.find('.bg');
    var scene, tween, controller;

    $(window).resize(onResize);
    onResize();

    function onResize() {
      if ($.isXs() || $.isSm()) {
        removeAnim();
      } else {
        initAnim();
      }
    }

    function initAnim() {
      removeAnim();

      if (!shouldParallax()) { return; }

      controller = new ScrollMagic.Controller();

      tween = new TimelineMax().add([
        TweenMax.to(bg, 1, { y: $(window).height() / 2, ease: Linear.easeNone })
      ]);

      scene = new ScrollMagic.Scene({ duration: $(window).height() }).setTween(tween).addTo(controller);
    }

    function removeAnim() {
      if (controller) {
        controller.destroy(true);
        controller = null;
      }
    }

  };
}(jQuery));

// blogBannerItem
(function ($) {

  'use strict';

  $.fn.blogBannerItem = function () {

    // protection
    if (!this.length) { return; }
    //

    var blogBannerItem = $(this);
    var bg = blogBannerItem.find('.bg');
    var scene, tween, controller;

    $(window).resize(onResize);
    onResize();

    function onResize() {
      if ($.isXs() || $.isSm()) {
        removeAnim();
      } else {
        initAnim();
      }
    }

    function initAnim() {
      removeAnim();

      if (!shouldParallax()) { return; }

      controller = new ScrollMagic.Controller();

      tween = new TimelineMax().add([
        TweenMax.to(bg, 1, { y: $(window).height() / 2, ease: Linear.easeNone })
      ]);

      scene = new ScrollMagic.Scene({ duration: $(window).height() }).setTween(tween).addTo(controller);
    }

    function removeAnim() {
      if (controller) {
        controller.destroy(true);
        controller = null;
      }
    }

  };
}(jQuery));

// postsCategories
(function ($) {

  'use strict';

  $.fn.postsCategories = function () {

    // protection
    if (!this.length) { return; }
    //

    var postsCategories = $(this);
    var mainHeader = $('.mainHeader');

    $(window).scroll(onScroll);
    $(window).resize(onScroll);

    function onScroll() {
      // ----- reset every time
      postsCategories.removeClass('fixed');
      TweenLite.set(postsCategories, { top: 'auto' });
      // -----

      if ($.isLg()) {
        var top = postsCategories.offset().top;

        if ($(window).scrollTop() > top - mainHeader.outerHeight()) {
          postsCategories.addClass('fixed');
          TweenLite.set(postsCategories, { top: mainHeader.outerHeight() });
        }
      }
    }

  };
}(jQuery));

// genericBanner
(function ($) {

  'use strict';

  $.fn.genericBanner = function () {

    // protection
    if (!this.length) { return; }
    //

    var genericBanner = $(this);
    var genericBannerContainer = genericBanner.find('.genericBannerContainer');
    var genericBannerContent = genericBanner.find('.genericBannerContent');
    var genericBannerArrowDown = genericBanner.find('.genericBannerArrowDown');
    var scene, tween, controller;

    $(window).resize(onResize);
    onResize();

    function onResize() {
      if ($.isXs() || $.isSm()) {
        removeAnim();
      } else {
        initAnim();
      }
    }

    function initAnim() {
      removeAnim();

      if (!shouldParallax()) { return; }

      controller = new ScrollMagic.Controller();

      tween = new TimelineMax().add([
        TweenMax.to(genericBannerContainer, 1, { y: $(window).height() / 2, ease: Linear.easeNone }),
        TweenMax.to(genericBannerArrowDown, 1, { y: $(window).height() / 1.5, ease: Linear.easeNone }),
        TweenMax.to(genericBannerContent, 0.3, { delay: 0.2, opacity: 0, ease: Linear.easeNone })
      ]);

      scene = new ScrollMagic.Scene({ duration: $(window).height() }).setTween(tween).addTo(controller);
    }

    function removeAnim() {
      if (controller) {
        controller.destroy(true);
        controller = null;
      }
    }

  };
}(jQuery));

// homeBanner
(function ($) {

  'use strict';

  $.fn.homeBanner = function () {

    // protection
    if (!this.length) { return; }
    //

    var homeBanner = $(this);
    var homeBannerContainer = homeBanner.find('.homeBannerContainer');
    var homeBannerContent = homeBanner.find('.homeBannerContent');
    var homeBannerArrowDown = homeBanner.find('.homeBannerArrowDown');
    var scene, tween, controller;

    //---------------------------------------

    var homeVideo = homeBanner.find('.homeVideo');
    homeVideo.backgroundVideo();

    var circleAnimation = homeBanner.find('.circleAnimation');
    startCircleAnimation();

    $(window).resize(onResize);
    onResize();

    function onResize() {
      if ($.isXs() || $.isSm()) {
        removeAnim();
      } else {
        initAnim();
      }

      TweenMax.set(homeBanner, { height: $(window).height() });
    }

    function initAnim() {
      removeAnim();

      if (!shouldParallax()) { return; }

      controller = new ScrollMagic.Controller();

      tween = new TimelineMax().add([
        TweenMax.to(homeBannerContainer, 1, { y: $(window).height() / 2, ease: Linear.easeNone }),
        TweenMax.to(homeBannerArrowDown, 1, { y: $(window).height() / 1.5, ease: Linear.easeNone }),
        TweenMax.to(homeBannerContent, 0.3, { delay: 0.2, opacity: 0, ease: Linear.easeNone })
      ]);

      scene = new ScrollMagic.Scene({ duration: $(window).height() }).setTween(tween).addTo(controller);
    }

    function removeAnim() {
      if (controller) {
        controller.destroy(true);
        controller = null;
      }
    }

    function startCircleAnimation() {
      var speed = 4;
      var circles = circleAnimation.find('.circle');
      var one = circleAnimation.find('.circleOne');
      var two = circleAnimation.find('.circleTwo');
      var three = circleAnimation.find('.circleThree');

      /*var s1 = 600;
      var s2 = s1 / 2;
      var s3 = s1 / 4;
      var s4 = s1 / 6;

      var bezierPath = [{x: s1, y: 0}, {x: 0, y: s2}, {x: -s3, y: 0}, {x: 0, y: -s4}, {x: 0, y: 0}];*/

      circles.each(function (index) {

        var item = $(this);
        var s;

        if (item.is(one)) {
          s = 53;
        } else if (item.is(two)) {
          s = 33;
        } else if (item.is(three)) {
          s = 24;
        }

        s = s / 4;

        var bezierPath = [
          { x: (s * 48.1), y: -(s * 11.9) },
          { x: (s * 3.72), y: (s * 32.4) },
          { x: -(s * 31.8), y: -(s * 3.09) },
          { x: -(s * 3.38), y: -(s * 31.5) },
          { x: (s * 19.3), y: -(s * 8.78) },
          { x: (s * 1.16), y: (s * 9.42) },
          { x: -(s * 13.3), y: -(s * 5.14) },
          { x: -(s * 1.74), y: -(s * 16.7) },
          { x: (s * 7.57), y: -(s * 7.47) },
          { x: 0, y: 0 }
        ];

        var tl = new TimelineMax({ delay: 1 + index * (speed / 6) });
        tl.set(item, { display: 'block', x: -(s * 7.38), y: -(s * 67.5), scale: 2 });
        tl.to(item, speed, {
          scale: 1, bezier: {
            type: "soft",
            values: bezierPath,
            curviness: 2,
            autoRotate: true
          }, ease: Power3.easeOut
        });

      });

    }

  };
}(jQuery));

// contactMap
(function ($) {

  'use strict';

  $.fn.contactMap = function () {

    // protection
    if (!this.length) { return; }
    //

    var lat = -23.5668917;
    var lng = -46.7071181;

    var map = new GMaps({
      el: '#contactMapContent',
      lat: lat,
      lng: lng,
      scrollwheel: false,
      panControl: true,
      zoomControl: true,
      streetViewControl: false,
      mapTypeControl: false,
      overviewMapControl: false
    });

    map.addMarker({
      lat: lat,
      lng: lng,
      title: 'Voxel Digital',
      icon: templateUrl + '/dist/images/marker-active.png',
      infoWindow: {
        content: '<b>VOXEL DIGITAL</b><br>Rua Agostinho Cantu, 675, <br>Butantã, São Paulo - SP'
      }
    });

    var styles = [{ 'featureType': 'all', 'elementType': 'labels.text.fill', 'stylers': [{ 'saturation': 36 }, { 'color': '#333333' }, { 'lightness': 40 }] }, { 'featureType': 'all', 'elementType': 'labels.text.stroke', 'stylers': [{ 'visibility': 'on' }, { 'color': '#ffffff' }, { 'lightness': 16 }] }, { 'featureType': 'all', 'elementType': 'labels.icon', 'stylers': [{ 'visibility': 'off' }] }, { 'featureType': 'administrative', 'elementType': 'geometry.fill', 'stylers': [{ 'color': '#fefefe' }, { 'lightness': 20 }] }, { 'featureType': 'administrative', 'elementType': 'geometry.stroke', 'stylers': [{ 'color': '#fefefe' }, { 'lightness': 17 }, { 'weight': 1.2 }] }, { 'featureType': 'landscape', 'elementType': 'geometry', 'stylers': [{ 'color': '#f5f5f5' }, { 'lightness': 20 }] }, { 'featureType': 'poi', 'elementType': 'geometry', 'stylers': [{ 'color': '#f5f5f5' }, { 'lightness': 21 }] }, { 'featureType': 'poi.park', 'elementType': 'geometry', 'stylers': [{ 'color': '#dedede' }, { 'lightness': 21 }] }, { 'featureType': 'road.highway', 'elementType': 'geometry.fill', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 17 }] }, { 'featureType': 'road.highway', 'elementType': 'geometry.stroke', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 29 }, { 'weight': 0.2 }] }, { 'featureType': 'road.arterial', 'elementType': 'geometry', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 18 }] }, { 'featureType': 'road.local', 'elementType': 'geometry', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 16 }] }, { 'featureType': 'transit', 'elementType': 'geometry', 'stylers': [{ 'color': '#f2f2f2' }, { 'lightness': 19 }] }, { 'featureType': 'water', 'elementType': 'geometry', 'stylers': [{ 'color': '#e9e9e9' }, { 'lightness': 17 }] }];

    map.addStyle({
      styledMapName: 'Styled Map',
      styles: styles,
      mapTypeId: 'map_style'
    });

    map.setStyle('map_style');
    //google.maps.event.trigger(map.markers[0], 'click');

  };
}(jQuery));

// homeBlog
(function ($) {

  'use strict';

  $.fn.homeBlog = function () {

    // protection
    if (!this.length) { return; }
    //

    var homeBlog = $(this);
    var video = homeBlog.find('.video');
    plyr.setup(video.get(0), { autoplay: false });

  };
}(jQuery));

// productBanner
(function ($) {

  'use strict';

  $.fn.productBanner = function () {

    // protection
    if (!this.length) { return; }
    //

    var productBanner = $(this);
    var productBannerContainer = productBanner.find('.productBannerContainer');
    var productBannerContent = productBanner.find('.productBannerContent');
    var productBannerArrowDown = productBanner.find('.productBannerArrowDown');
    var scene, tween, controller;

    $(window).resize(onResize);
    onResize();

    function onResize() {
      if ($.isXs() || $.isSm()) {
        removeAnim();
      } else {
        initAnim();
      }

      TweenMax.set(productBanner, { height: $(window).height() });
    }

    function initAnim() {
      removeAnim();

      if (!shouldParallax()) { return; }

      controller = new ScrollMagic.Controller();

      tween = new TimelineMax().add([
        TweenMax.to(productBannerContainer, 1, { y: $(window).height() / 2, ease: Linear.easeNone }),
        TweenMax.to(productBannerArrowDown, 1, { y: $(window).height() / 1.5, ease: Linear.easeNone }),
        TweenMax.to(productBannerContent, 0.3, { delay: 0.2, opacity: 0, ease: Linear.easeNone })
      ]);

      scene = new ScrollMagic.Scene({ duration: $(window).height() }).setTween(tween).addTo(controller);
    }

    function removeAnim() {
      if (controller) {
        controller.destroy(true);
        controller = null;
      }
    }

  };
}(jQuery));

// aboutBanner
(function ($) {

  'use strict';

  $.fn.aboutBanner = function () {

    // protection
    if (!this.length) { return; }
    //

    var aboutBanner = $(this);
    var aboutBannerContainer = aboutBanner.find('.aboutBannerContainer');
    var aboutBannerContent = aboutBanner.find('.aboutBannerContent');
    var aboutBannerArrowDown = aboutBanner.find('.aboutBannerArrowDown');
    var scene, tween, controller;

    $(window).resize(onResize);
    onResize();

    function onResize() {
      if ($.isXs() || $.isSm()) {
        removeAnim();
      } else {
        initAnim();
      }
    }

    function initAnim() {
      removeAnim();

      if (!shouldParallax()) { return; }

      controller = new ScrollMagic.Controller();

      tween = new TimelineMax().add([
        TweenMax.to(aboutBannerContainer, 1, { y: $(window).height() / 2, ease: Linear.easeNone }),
        TweenMax.to(aboutBannerArrowDown, 1, { y: $(window).height() / 1.5, ease: Linear.easeNone }),
        TweenMax.to(aboutBannerContent, 0.3, { delay: 0.2, opacity: 0, ease: Linear.easeNone })
      ]);

      scene = new ScrollMagic.Scene({ duration: $(window).height() }).setTween(tween).addTo(controller);
    }

    function removeAnim() {
      if (controller) {
        controller.destroy(true);
        controller = null;
      }
    }

  };
}(jQuery));

// trackRecords
(function ($) {

  'use strict';

  $.fn.trackRecords = function () {

    // protection
    if (!this.length) { return; }
    //

    var trackRecords = $(this);
    var trackRecordsItems = trackRecords.find('#trackRecordsItems li');
    var min = trackRecordsItems.first().data('year');
    var max = trackRecordsItems.last().data('year');
    var duration = 1;

    var ballon = $("#trackRecords #yearBallon");
    var title = $("#trackRecords .container h3");
    var bigYear = $("#trackRecords #bigYear");
    var content = $("#trackRecords #content");
    var front = $("#track .front");
    var back = $("#track .back");
    var pointWidth = 32;
    var totalPoints = trackRecordsItems.length - 1;
    var lastYear = 1997;
    var nowIndex = 0;

    ballon.text(min);
    ballon.css('margin-left', front.width() - (ballon.width() / 2) - (pointWidth / 2));
    showTrackItem(0);

    function showTrackItem(index) {
      nowIndex = index;
      var nowInfo = trackRecordsItems.eq(index);
      var pct = norm(nowInfo.data('year'), min, max);
      var w = lerp(pct, pointWidth, back.width());

      lastYear = parseInt(ballon.text());

      title.text(nowInfo.find('.title').text());
      content.text(nowInfo.find('.content').text());

      var ballonYear = parseInt(nowInfo.data('year'));

      /*TweenMax.to(ballon, duration, {marginLeft:front.width() - (ballon.width() / 2) - (pointWidth / 2), ease:Power2.easeOut, onUpdate:onUpdate});

      function onUpdate() {
        if(front.width() === pointWidth) {
          front.addClass('small');
        } else {
          front.removeClass('small');
        }

        var ballonText = Math.round(lerp(this.animCurrentPct, lastYear, ballonYear));

        ballon.css('margin-left', front.width() - (ballon.width() / 2) - (pointWidth / 2));
        ballon.text(ballonText);
        bigYear.text(ballonText);
      }*/

      var tween = TweenMax.to(front, duration, { width: w, ease: Power2.easeOut, onUpdate: onUpdate });

      function onUpdate() {
        var progress = tween.progress();

        if (front.width() === pointWidth) {
          front.addClass('small');
        } else {
          front.removeClass('small');
        }

        var ballonText = Math.round(lerp(progress, lastYear, ballonYear));

        ballon.css('margin-left', front.width() - (ballon.width() / 2) - (pointWidth / 2));
        ballon.text(ballonText);
        bigYear.text(ballonText);
      }

      /*front.stop().animate(
      { width: w, animCurrentPct : 1 },
      {
        duration: duration,
        easing: 'easeOutExpo',
        progress: function() {
            if(front.width() === pointWidth) {
              front.addClass('small');
            } else {
              front.removeClass('small');
            }

            var ballonText = Math.round(lerp(this.animCurrentPct, lastYear, ballonYear));

            ballon.css('margin-left', front.width() - (ballon.width() / 2) - (pointWidth / 2));
            ballon.text(ballonText);
            bigYear.text(ballonText);

        },
        always: function() {
            this.animCurrentPct = 0;
        }
      });*/
    }

    $(window).resize(onResize);
    onResize();

    function onResize() {

      $("#trackRecords .container #track .back .pointRecord").each(function () {
        var pct = norm($(this).data('year'), min, max);
        var pos = lerp(pct, 0, back.width() - pointWidth);

        //console.log(pos);
        $(this).css('margin-left', pos);
      });

      showTrackItem(nowIndex);
    }

    // create the POINTS
    trackRecordsItems.each(function (index) {

      var pct = norm($(this).data('year'), min, max);
      var pos = lerp(pct, 0, back.width() - pointWidth);

      back.append('<div data-year="' + $(this).data('year') + '" data-index="' + index + '" class="point pointRecord" style="margin-left:' + pos + 'px;"></div>');
    });

    // click event on POINTS
    $("#track .back .point").click(function () {
      showTrackItem($(this).data('index'));
    });

    $("#buttons .btn").click(function (event) {
      event.preventDefault();

      if ($(this).hasClass('btn-left')) {
        showTrackItem(clamp(nowIndex - 1, 0, totalPoints));
      }
      else if ($(this).hasClass('btn-right')) {
        showTrackItem(clamp(nowIndex + 1, 0, totalPoints));
      }
    });

  };
}(jQuery));

// clientesFlip
(function ($) {

  'use strict';

  $.fn.clientesFlip = function () {

    // protection
    if (!this.length) { return; }
    //

    //var clientesFlip = $(this);
    var containerInvisible = $('#clientesContainerInvisible');
    var logoContainer = $('#clientesContainer');
    var maxLenght = ($.isXs() || $.isSm()) ? 6 : 12;
    var logos = containerInvisible.children();
    var currentIndex = 0;
    var changeTime = 1000;

    for (var i = 0; i < maxLenght; i++) {
      var logo = $(logos[getIndex()]).clone();
      logoContainer.append(logo);
    }

    TweenLite.set(".cardWrapper", { perspective: 800 });
    TweenLite.set(".card", { transformStyle: "preserve-3d" });
    TweenLite.set(".back", { rotationY: -180 });
    TweenLite.set([".back", ".front"], { backfaceVisibility: "hidden" });

    setInterval(function () {
      showNewLogo($('#clientesContainer .logo:eq(' + getUniqueRandom() + ')'));
    }, changeTime);

    function getIndex() {
      var index = currentIndex;
      currentIndex++;

      if (currentIndex === logos.length) {
        currentIndex = 0;
      }

      return index;
    }

    function showNewLogo(item) {
      var front = item.find('.front');
      var back = item.find('.back');
      var newLogo = $(logos[getIndex()]).find('img').clone();

      if (front.hasClass('active')) {

        // remove first
        front.removeClass('active');

        back.empty();
        back.append(newLogo);
        back.addClass('active');

        // animate
        TweenLite.to(item.find(".card"), 1, { rotationY: 180, ease: Expo.easeOut });

      } else if (back.hasClass('active')) {

        // remove first
        back.removeClass('active');

        front.empty();
        front.append(newLogo);
        front.addClass('active');

        // animate
        TweenLite.to(item.find(".card"), 1, { rotationY: 0, ease: Back.easeOut });
      }
    }

    $.fn.random = function () {
      return this.eq(getUniqueRandom());
    };

    var uniqueRandoms = [];

    function getUniqueRandom() {
      // refill the array if needed
      if (!uniqueRandoms.length) {
        //console.log('---------')
        for (var i = 0; i < maxLenght; i++) {
          uniqueRandoms.push(i);
        }
      }
      var index = Math.floor(Math.random() * uniqueRandoms.length);
      var val = uniqueRandoms[index];

      // now remove that value from the array
      uniqueRandoms.splice(index, 1);

      //console.log(val);

      return val;
    }
  };
}(jQuery));

// productVideo
(function ($) {

  'use strict';

  $.fn.productVideo = function () {

    // protection
    if (!this.length) { return; }
    //

    var productVideo = $(this);
    var squareOne = productVideo.find('.squareOne');
    var squareTwo = productVideo.find('.squareTwo');
    var squareContainer = squareOne.find('.squareContainer');
    var videoContainer = squareOne.find('.videoContainer');
    var videoContent = squareOne.find('.videoContent');
    var videoCloseArea = squareOne.find('.videoCloseArea');
    var video = videoContent.find('.video');
    var player;
    var animating = false;
    var playerVolume;
    var speed = 1;
    var isOpen = false;
    var tl;

    productVideo.on('VIDEO_OPEN', open);
    productVideo.on('VIDEO_CLOSE', close);

    $(window).resize(onResize);

    //------------

    function open() {
      if (animating) { return; }
      animating = true;
      isOpen = true;

      if (player) {
        //player[0].play();
      }

      //--------------------

      if (tl) {
        tl.play();
      } else {
        tl = new TimelineMax({ onComplete: openComplete, onReverseComplete: onReverseComplete });
        tl.set(videoContainer, { display: 'block' });
        tl.fromTo(squareOne, speed, { width: '50%' }, { width: '100%', ease: Power2.easeInOut });
        tl.fromTo(squareTwo, speed, { left: '50%' }, { left: '100%', ease: Power2.easeInOut }, '-=' + speed);
        tl.to(videoContainer, speed, { opacity: 1, ease: Power2.easeInOut }, '-=' + speed);
        tl.to(squareContainer, speed, { autoAlpha: 0, ease: Power2.easeInOut }, '-=' + speed);
      }
    }

    function onReverseComplete() {
      animating = false;
      player[0].pause();
      resizeVideo();
    }

    function openComplete() {
      animating = false;

      if (!player) {
        player = plyr.setup(video.get(0), { autoplay: true });
      }

      playerVolume = player[0].getVolume();
      resizeVideo();
    }

    function close() {
      if (animating) { return; }
      animating = true;
      isOpen = false;

      //--------------------

      tl.reverse();
    }

    function resizeVideo() {
      var h = videoContainer.height();
      var w = h * (16 / 9);

      TweenMax.set(videoContent, { width: w, height: h });
    }

    function onResize() {
      resizeVideo();
    }

    squareOne.click(function () {
      //productVideo.trigger('VIDEO_OPEN');
    });

    videoCloseArea.click(function () {
      //productVideo.trigger('VIDEO_CLOSE');
    });

  };
}(jQuery));

// productSolution
(function ($) {

  'use strict';

  $.fn.productSolution = function () {

    // protection
    if (!this.length) { return; }
    //

    var productSolution = $(this);
    var collums = productSolution.find('.collums');
    var itemDetailContainer = productSolution.find('.itemDetailContainer');
    var itemDetailTextContainer = itemDetailContainer.find('.textContainer');
    var itemDetailTextContent = itemDetailTextContainer.find('.textContent');
    var imageDetailContainer = itemDetailContainer.find('.imageContainer');
    var imageDetailContent = imageDetailContainer.find('.imageContent');
    var closeButton = itemDetailContainer.find('.button');
    var timeline;
    var animating = false;

    var gridContainer = productSolution.find('.gridContainer');
    var items = gridContainer.find('.item');
    var selectedItem = gridContainer.find('*[data-selected]');

    items.click(function () {
      itemClick($(this));
    });

    // ------- 
    function itemClick(item) {
      var url = item.attr('data-url');

      if (window.location.href.search(url) !== -1) {
        // já tem o url, então faz reload
        window.location.reload();
      } else {
        window.location.href = url;
      }
    }

    function itemOpen(item, instant) {

      if (animating) { return; }
      animating = true;

      //------------

      var speed = 0.4;
      var imageXS = item.attr('data-image-xs');
      var imageXL = item.attr('data-image-xl');
      var imageXXL = item.attr('data-image-xxl');

      itemDetailTextContent.html(item.find('.itemDetail').html());

      imageDetailContent.html(
        '<img ' +
        'src="' + imageXS + '" ' +
        'data-sizes="auto" ' +
        'data-srcset="' + imageXXL + ' 2x, ' + imageXL + ' 800w"' +
        'class="lazyload blur-up" ' +
        '/>'
      );

      //TweenLite.to(window, speed, {scrollTo:{y:productSolution.position().top - mainHeader.outerHeight()}, ease:Power2.easeInOut});
      //TweenLite.set(window, {scrollTo:{y:productSolution.position().top - mainHeader.outerHeight()}});

      if (timeline) {
        timeline.play();
      } else {
        timeline = new TimelineMax({ onComplete: onComplete, onReverseComplete: onReverseComplete });
        timeline.fromTo(itemDetailContainer, 0.1, { display: 'none' }, { display: 'block' });
        timeline.fromTo(gridContainer, speed, { autoAlpha: 1 }, { autoAlpha: 0, ease: Power2.easeOut });
        timeline.from(imageDetailContainer, speed, { xPercent: '120%', ease: Power2.easeOut }, '-=' + (speed / 2));
        timeline.from(itemDetailTextContainer, speed, { y: 70, opacity: 0, ease: Power2.easeOut }, '-=' + speed);
      }

      if (instant) {
        timeline.seek(timeline.endTime());
      }

      //------------

      // HABILITAR O SCROLL
      $('*[data-scroll-to-object]').scrollToObject();

      // HABILITAR TRIGGER PARA ABRIR LIGHTBOX
      $('.openLightbox').click(function (event) {
        event.preventDefault();
        lightboxTrigger();
      });
    }

    function lightboxTrigger() {
      $('#lightboxTrigger').parent().click();
    }

    function onComplete() {
      animating = false;
    }

    function onReverseComplete() {
      animating = false;
    }

    function closeItem() {
      if (animating) { return; }
      animating = true;

      //------------

      timeline.reverse();
    }

    closeButton.click(closeItem);

    // ----------- PARALLAX

    var scene, tween, controller;
    var dotOne = collums.find('.dotOne');
    var dotTwo = collums.find('.dotTwo');
    var dotThree = collums.find('.dotThree');
    var dotFour = collums.find('.dotFour');

    $(window).resize(onResize);


    onResize();

    function onResize() {
      if ($.isXs() || $.isSm()) {
        removeAnim();
        //if(timeline) {timeline.pause(0);}
      } else {
        initAnim();
      }
    }

    function initAnim() {
      removeAnim();

      if (!shouldParallax()) { return; }

      controller = new ScrollMagic.Controller();

      tween = new TimelineMax().add([
        TweenMax.fromTo(dotOne, 1, { y: -20 }, { y: 20, ease: Linear.easeNone }),
        TweenMax.to(dotTwo, 1, { y: 100, ease: Linear.easeNone }),
        TweenMax.fromTo(dotThree, 1, { y: -100 }, { y: 100, ease: Linear.easeNone }),
        TweenMax.fromTo(dotFour, 1, { y: -50 }, { y: 50, ease: Linear.easeNone })
      ]);

      scene = new ScrollMagic.Scene({
        duration: $(window).height(),
        triggerElement: productSolution.get(0)
      }).setTween(tween).addTo(controller);
    }

    function removeAnim() {
      if (controller) {
        controller.destroy(true);
        controller = null;
      }
    }

    // ------------------------------- BASED ON VARIABLE

    // se o item está selecionado abre no inicio
    if (selectedItem.length) {
      itemOpen(selectedItem);
    }
  };
}(jQuery));

// productFunctions
(function ($) {

  'use strict';

  $.fn.productFunctions = function () {

    // protection
    if (!this.length) { return; }
    //

    var productFunctions = $(this);

    //---------------------- DESKTOP VERSION

    var desktopVersion = productFunctions.find('.desktopVersion');
    var image = desktopVersion.find('.image');
    var imageNotCurrent = desktopVersion.find('.image:not(.current)');
    var buttonContainer = desktopVersion.find('.buttonContainer');
    var footerText = productFunctions.find('.footerText');
    var buttonsParents = buttonContainer.find('li');
    var buttons = buttonContainer.find('.btn');

    buttons.click(function (event) {
      event.preventDefault();

      var item = $(this);
      var li = item.parent();
      var itemImage = item.attr('data-image');
      var itemVideo = item.attr('data-video');
      var videoOrImage = hasAttribute(item, 'data-image') ? 'image' : 'video';

      var itemText = item.find('.itemDetail').html();

      // ------ ADD IMAGE

      if (videoOrImage === 'image') {
        imageNotCurrent.html('<img data-src="' + itemImage + '" class="lazyload">');
      } else {
        imageNotCurrent.html('<iframe data-src="https://www.youtube.com/embed/' + itemVideo + '?enablejsapi=1&version=3&playerapiid=ytplayer" frameborder="0" allowfullscreen class="youtube_player_iframe lazyload"></iframe>');
      }

      // ------ STOP ALL VIDEOS

      stopAllVideos();

      // ----------------

      image.toggleClass('current');
      imageNotCurrent = productFunctions.find('.image:not(.current)');

      footerText.html(itemText);

      buttonsParents.removeClass('active');
      li.addClass('active');
    });

    function stopAllVideos() {
      $('.youtube_player_iframe').each(function () {
        this.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
      });
    }

    function hasAttribute(object, attribute) {
      var attr = $(object).attr(attribute);
      return typeof attr !== typeof undefined && attr !== false;
    }

    buttons[0].click();

    //---------------------- MOBILE VERSION

    var mobileVersion = productFunctions.find('.mobileVersion');
    var mainCarousel = mobileVersion.find('.mainCarousel');
    var navCarousel = mobileVersion.find('.navCarousel');
    var mainCarouselItems = mainCarousel.find('.item');
    var tooMuch = mainCarouselItems.length > 2;

    mainCarousel.flickity({
      wrapAround: tooMuch,
      cellAlign: 'center',
      prevNextButtons: false,
      pageDots: false
    });

    navCarousel.flickity({
      asNavFor: '.mainCarousel',
      wrapAround: tooMuch,
      cellAlign: 'center',
      prevNextButtons: false,
      pageDots: false
    });

    var flkty = mainCarousel.data('flickity');

    $(mainCarousel, navCarousel).on('select.flickity', function () {
      var index = flkty.selectedIndex;
      var button = $(buttons[index]);
      var itemText = button.find('.itemDetail').html();
      footerText.html(itemText);
    });

  };
}(jQuery));

// productGallery
(function ($) {

  'use strict';

  $.fn.productGallery = function () {

    // protection
    if (!this.length) { return; }
    //

    var productGallery = $(this);
    var productGalleryContent = productGallery.find('.productGalleryContent');
    var buttonContainer = productGalleryContent.find('.grid-item-button-container');
    var gridItems = productGalleryContent.find('.grid-item-content');

    productGalleryContent.photoswipe({
      bgOpacity: 0.9,
      showHideOpacity: true,
      history: false,
      captionEl: true,
      shareEl: false,
      loop: true
    });

    buttonContainer.click(function () {
      $(gridItems[0]).click();
    });

  };
}(jQuery));

// scrollToObject
(function ($) {

  'use strict';

  $.fn.scrollToObject = function () {

    // protection
    if (!this.length) { return; }
    //

    $(this).click(function (event) {

      event.preventDefault();

      var id = $(this).attr('href');
      var offset = $(this).attr('data-scroll-to-object-offset') ? $(this).attr('data-scroll-to-object-offset') : 0;

      //---------------------

      if (hasHeaderOffset($(this))) {
        offset = headerHeight();
        console.log(offset);
      }

      //---------------------

      var time = $(this).attr('data-scroll-to-object-time') ? $(this).attr('data-scroll-to-object-time') : 3;
      var object = $(id);
      var pos = object.offset();
      var y = Number(pos.top) - Number(offset);

      TweenLite.to(window, time, { scrollTo: { y: y }, ease: Power2.easeInOut });
    });

    function hasHeaderOffset(item) {
      var attr = item.attr('data-header-offset');
      return typeof attr !== typeof undefined && attr !== false;
    }

    function headerHeight() {
      var h = 80;

      if ($.isLg()) {
        h = 80;
      } else if ($.isMd() || $.isSm()) {
        h = 70;
      } else if ($.isXs()) {
        h = 0;
      }

      return h;
    }
  };
}(jQuery));

// socialSidebar
(function ($) {

  'use strict';

  $.fn.socialSidebar = function () {

    var socialSidebar = $(this);

    $(window).scroll(onScroll);
    onScroll();

    function onScroll() {
      if ($(window).scrollTop() < $(window).height() / 2) {
        socialSidebar.removeClass('show');
      }
      else {
        socialSidebar.addClass('show');
      }
    }

  };

}(jQuery));

// mainSidebar
(function ($) {

  'use strict';

  $.fn.mainSidebar = function () {

    /*jshint camelcase:false */

    // protection
    if (!this.length) { return; }
    //

    var mainSidebar = $(this);

    $(window).resize(onResize);
    onResize();

    function onResize() {
      checkToPin();
    }

    function checkToPin() {
      if ($.isXs() || $.isSm()) {
        mainSidebar.trigger('sticky_kit:detach');
      } else {
        mainSidebar.trigger('sticky_kit:detach');

        if (mainSidebar.hasClass('questionSidebar')) {
          mainSidebar.stick_in_parent({ offset_top: 80 + 70 + 30 });

        } else if (mainSidebar.hasClass('courseSidebar')) {
          //mainSidebar.stick_in_parent({offset_top:50, recalc_every:5});
        }
        else {
          mainSidebar.stick_in_parent({ offset_top: 80 + 30 });
        }
      }
    }

  };
}(jQuery));

// productDetailPriceContainer
(function ($) {

  'use strict';

  $.fn.productDetailPriceContainer = function () {

    /*jshint camelcase:false */

    // protection
    if (!this.length) { return; }
    //

    var pinnedPriceContainer = $(this);
    var courseInformationStrip = $('.courseInformationStrip');

    $(window).resize(onResize);
    $(window).scroll(onScroll);
    onResize();

    function onScroll() {
      var pos = courseInformationStrip.offset();
      var shouldFade = $(window).scrollTop() > pos.top;

      TweenLite.to(pinnedPriceContainer, 1, { opacity: shouldFade ? 1 : 0, ease: Expo.easeOut });
    }

    function onResize() {
      checkToPin();
    }

    function checkToPin() {
      if ($.isXs() || $.isSm()) {
        pinnedPriceContainer.trigger('sticky_kit:detach');
      } else {
        pinnedPriceContainer.trigger('sticky_kit:detach');
        pinnedPriceContainer.stick_in_parent({ offset_top: 60 + 30 });
      }
    }

  };
}(jQuery));

// courseInformationStrip
(function ($) {

  'use strict';

  $.fn.courseInformationStrip = function () {

    /*jshint camelcase:false */

    // protection
    if (!this.length) { return; }
    //

    var courseInformationStrip = $(this);
    var itemsContainer = courseInformationStrip.find('.itemsContainer');
    var items = itemsContainer.find('.item');

    $.each(items, function () {

      var item = $(this);
      var popoverContent = item.find('.popoverContent');

      if (popoverContent) {

        item.popover({
          html: true,
          placement: 'bottom',
          container: 'body',
          trigger: 'hover',
          content: function () {
            return popoverContent.html();
          }
        });
      }
    });

  };
}(jQuery));

// sectionTwo
(function ($) {

  'use strict';

  $.fn.sectionTwo = function () {

    /*jshint camelcase:false */

    // protection
    if (!this.length) { return; }
    //

    var sectionTwo = $(this);
    var owl = sectionTwo.find('.owl-carousel');
    var calendar = sectionTwo.find('#calendar');
    /*var sidebarMenu = sectionTwo.find('#sidebarMenu');
    var sidebarMenuItem = sidebarMenu.find('li');
    var controller;
    var scene;*/

    owl.owlCarousel({
      items: 1,
      autoplay: true,
      loop: true,
      autoplayHoverPause: true,
      autoplaySpeed: 1000,
      smartSpeed: 1000,
      touchDrag: false,
      mouseDrag: true,
      nav: true,
      navContainer: '#calendarNav',
      navText: ['<div class="navContent"><i class="fa fa-angle-left"></i></div>', '<div class="navContent"><i class="fa fa-angle-right"></i></div>']
    });

    $(window).scroll(function () {
      owl.trigger('stop.owl.autoplay');
      owl.trigger('play.owl.autoplay');
    });

    // ----------- SCENE

    $(window).resize(onResize);
    onResize();

    function onResize() {
      //checkToAnimate();
      checkToPin();
    }

    function checkToPin() {
      if ($.isXs() || $.isSm()) {
        $(calendar).trigger('sticky_kit:detach');
      } else {
        $(calendar).trigger('sticky_kit:detach');
        $(calendar).stick_in_parent({ offset_top: 60 + 30 });
      }
    }

    /*function checkToAnimate() {
      if($.isXs() || $.isSm() || $.isMd()) {

        if(controller) {
          controller.destroy(true);
          controller = null;
        }

        if(scene) {
          scene.destroy(true);
        }

      } else {
        controller = new ScrollMagic.Controller();

        var tween = new TimelineMax().add([
          TweenMax.staggerFrom(sidebarMenuItem, 1, {y: 500, ease:Power2.easeOut}, .2)
        ]);

        scene = new ScrollMagic.Scene({duration: $(window).height(), offset:$(window).height() / 3}).setTween(tween).addTo(controller);
      }
    }*/


  };
}(jQuery));

// backToTopButton 
(function ($) {
  /*jshint validthis:true */

  'use strict';

  $.fn.backToTopButton = function () {
    var backToTopButton = $(this);

    backToTopButton.click(function (event) {
      event.preventDefault();
      TweenLite.to(window, 2, { scrollTo: { y: 0 }, ease: Expo.easeOut });
    });

    $(window).scroll(onScroll);
    onScroll();

    function onScroll() {
      if ($(window).scrollTop() < $(window).height() / 2) {
        backToTopButton.removeClass('show');
      }
      else {
        backToTopButton.addClass('show');
      }
    }

  };

}(jQuery));


// sectionTestimonial
(function ($) {

  'use strict';

  $.fn.sectionTestimonial = function () {

    // protection
    if (!this.length) { return; }
    //

    var sectionTestimonial = $(this);
    var owl = sectionTestimonial.find('.owl-carousel');

    owl.owlCarousel({
      items: 1,
      autoplay: true,
      loop: true,
      autoplayHoverPause: true,
      autoplaySpeed: 1000,
      smartSpeed: 1000,
      nav: true,
      navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      dots: false
    });

    $(window).scroll(function () {
      owl.trigger('stop.owl.autoplay');
      owl.trigger('play.owl.autoplay');
    });

  };
}(jQuery));

// sectionStartNow
(function ($) {

  'use strict';

  $.fn.sectionStartNow = function () {

    // protection
    if (!this.length) { return; }
    //

    var sectionStartNow = $(this);
    var sectionStartNowHeight = $(sectionStartNow).outerHeight();
    var buttons = sectionStartNow.find('.btn');
    var scene;

    // ----------- SCENE

    var tween = new TimelineMax().add([
      TweenMax.staggerFrom($(buttons).get().reverse(), 1, { opacity: 0, x: -300, ease: Expo.easeOut }, 0.3),
    ]);

    scene = new ScrollMagic.Scene({ duration: $(window).height() / 3, triggerElement: '#sectionStartNow', triggerHook: 'onEnter', offset: sectionStartNowHeight }).setTween(tween).addTo(new ScrollMagic.Controller());

  };
}(jQuery));

// aboutGallery
(function ($) {

  'use strict';

  $.fn.aboutGallery = function () {

    // protection
    if (!this.length) { return; }
    //

    var aboutGallery = $(this);

    aboutGallery.photoswipe({
      bgOpacity: 0.9,
      showHideOpacity: true,
      history: true,
      captionEl: true,
      //shareEl: false,
      loop: true
    });
  };
}(jQuery));

// sectionPhotos
(function ($) {

  'use strict';

  $.fn.sectionPhotos = function () {

    // protection
    if (!this.length) { return; }
    //

    //var sectionPhotos = $(this);

    $('.sectionPhotosGallery').photoswipe({
      bgOpacity: 0.9,
      showHideOpacity: true,
      history: true,
      captionEl: true,
      //shareEl: false,
      loop: true
    });
  };
}(jQuery));

// sectionCourses
(function ($) {

  'use strict';

  $.fn.sectionCourses = function () {

    // protection
    if (!this.length) { return; }
    //

    var sectionCourses = $(this);
    var filterMenu = sectionCourses.find('.filterMenu');
    var filterMenuButtons = filterMenu.find('.btn');
    var contentRow = sectionCourses.find('.contentRow');
    //var products = sectionCourses.find('.gridItem');
    //var badges = products.find('.badgeDetail');
    var owl = sectionCourses.find('.owl-carousel');
    var usedOnGrid = sectionCourses.hasClass('usedOnGrid');
    //var scene;

    if (usedOnGrid) {
      // products are on grid
      $(contentRow).isotope({
        itemSelector: '.gridItemContainer',
        layoutMode: 'fitRows'
      });

      $(filterMenuButtons).on('click', function (event) {
        event.preventDefault();

        filterMenuButtons.removeClass('active');
        $(this).addClass('active');

        var filterValue = $(this).attr('data-filter');
        $(contentRow).isotope({ filter: filterValue });
      });

    } else {
      // products are on carousel
      owl.owlCarousel({
        responsive: {
          0: {
            items: 1
          },
          480: {
            items: 1
          },
          640: {
            items: 2
          },
          768: {
            items: 3
          },
          992: {
            items: 3
          },
          1200: {
            items: 4
          }
        },
        margin: 30,
        lazyLoad: true,
        autoplaySpeed: 1000,
        dotsContainer: '#coursesSliderDots',
        smartSpeed: 1000
      });
    }


    // ----------- SCENE

    /*var tween = new TimelineMax().add([
      TweenMax.from(badges, 1, {right: '-=200', ease:Power2.easeOut})
    ]);

    scene = new ScrollMagic.Scene({duration: $(window).height() / 3, triggerElement:'#sectionCourses'}).setTween(tween).addTo(new ScrollMagic.Controller());*/
  };
}(jQuery));

// sectionProducts
(function ($) {

  'use strict';

  $.fn.sectionProducts = function () {

    // protection
    if (!this.length) { return; }
    //

    var sectionProducts = $(this);
    var owl = sectionProducts.find('.owl-carousel');

    owl.owlCarousel({
      responsive: {
        0: {
          items: 1
        },
        480: {
          items: 1
        },
        640: {
          items: 2
        },
        768: {
          items: 3
        },
        992: {
          items: 3
        },
        1200: {
          items: 4
        }
      },
      margin: 30,
      lazyLoad: true,
      autoplaySpeed: 1000,
      dotsContainer: '#productsSliderDots',
      smartSpeed: 1000
    });

  };
}(jQuery));

function shouldParallax() {
  var bol = true;

  if (/MSIE 10/i.test(navigator.userAgent)) {
    // This is internet explorer 10
    bol = false;
  }

  if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
    // This is internet explorer 9 or 11
    bol = false;
  }

  if (/Edge\/\d./i.test(navigator.userAgent)) {
    // This is Microsoft Edge
    bol = false;
  }

  return bol;
}

/* jshint ignore:start */

/*!
 * ScrollMagic v2.0.5 (2015-04-29)
 * The javascript library for magical scroll interactions.
 * (c) 2015 Jan Paepke (@janpaepke)
 * Project Website: http://scrollmagic.io
 * 
 * @version 2.0.5
 * @license Dual licensed under MIT license and GPL.
 * @author Jan Paepke - e-mail@janpaepke.de
 *
 * @file ScrollMagic GSAP Animation Plugin.
 *
 * requires: GSAP ~1.14
 * Powered by the Greensock Animation Platform (GSAP): http://www.greensock.com/js
 * Greensock License info at http://www.greensock.com/licensing/
 */
/**
 * This plugin is meant to be used in conjunction with the Greensock Animation Plattform.  
 * It offers an easy API to trigger Tweens or synchronize them to the scrollbar movement.
 *
 * Both the `lite` and the `max` versions of the GSAP library are supported.  
 * The most basic requirement is `TweenLite`.
 * 
 * To have access to this extension, please include `plugins/animation.gsap.js`.
 * @requires {@link http://greensock.com/gsap|GSAP ~1.14.x}
 * @mixin animation.GSAP
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ScrollMagic', 'TweenMax', 'TimelineMax'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS
    // Loads whole gsap package onto global scope.
    require('gsap');
    factory(require('scrollmagic'), TweenMax, TimelineMax);
  } else {
    // Browser globals
    factory(root.ScrollMagic || (root.jQuery && root.jQuery.ScrollMagic), root.TweenMax || root.TweenLite, root.TimelineMax || root.TimelineLite);
  }
}(this, function (ScrollMagic, Tween, Timeline) {
  "use strict";
  var NAMESPACE = "animation.gsap";

  var
    console = window.console || {},
    err = Function.prototype.bind.call(console.error || console.log ||
      function () { }, console);
  if (!ScrollMagic) {
    err("(" + NAMESPACE + ") -> ERROR: The ScrollMagic main module could not be found. Please make sure it's loaded before this plugin or use an asynchronous loader like requirejs.");
  }
  if (!Tween) {
    err("(" + NAMESPACE + ") -> ERROR: TweenLite or TweenMax could not be found. Please make sure GSAP is loaded before ScrollMagic or use an asynchronous loader like requirejs.");
  }

  /*
     * ----------------------------------------------------------------
     * Extensions for Scene
     * ----------------------------------------------------------------
     */
  /**
   * Every instance of ScrollMagic.Scene now accepts an additional option.  
   * See {@link ScrollMagic.Scene} for a complete list of the standard options.
   * @memberof! animation.GSAP#
   * @method new ScrollMagic.Scene(options)
   * @example
   * var scene = new ScrollMagic.Scene({tweenChanges: true});
   *
   * @param {object} [options] - Options for the Scene. The options can be updated at any time.
   * @param {boolean} [options.tweenChanges=false] - Tweens Animation to the progress target instead of setting it.  
   Does not affect animations where duration is `0`.
   */
  /**
   * **Get** or **Set** the tweenChanges option value.  
   * This only affects scenes with a duration. If `tweenChanges` is `true`, the progress update when scrolling will not be immediate, but instead the animation will smoothly animate to the target state.  
   * For a better understanding, try enabling and disabling this option in the [Scene Manipulation Example](../examples/basic/scene_manipulation.html).
   * @memberof! animation.GSAP#
   * @method Scene.tweenChanges
   * 
   * @example
   * // get the current tweenChanges option
   * var tweenChanges = scene.tweenChanges();
   *
   * // set new tweenChanges option
   * scene.tweenChanges(true);
   *
   * @fires {@link Scene.change}, when used as setter
   * @param {boolean} [newTweenChanges] - The new tweenChanges setting of the scene.
   * @returns {boolean} `get` -  Current tweenChanges option value.
   * @returns {Scene} `set` -  Parent object for chaining.
   */
  // add option (TODO: DOC (private for dev))
  ScrollMagic.Scene.addOption("tweenChanges", // name
    false, // default


    function (val) { // validation callback
      return !!val;
    });
  // extend scene
  ScrollMagic.Scene.extend(function () {
    var Scene = this,
      _tween;

    var log = function () {
      if (Scene._log) { // not available, when main source minified
        Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ")", "->");
        Scene._log.apply(this, arguments);
      }
    };

    // set listeners
    Scene.on("progress.plugin_gsap", function () {
      updateTweenProgress();
    });
    Scene.on("destroy.plugin_gsap", function (e) {
      Scene.removeTween(e.reset);
    });

    /**
     * Update the tween progress to current position.
     * @private
     */
    var updateTweenProgress = function () {
      if (_tween) {
        var
          progress = Scene.progress(),
          state = Scene.state();
        if (_tween.repeat && _tween.repeat() === -1) {
          // infinite loop, so not in relation to progress
          if (state === 'DURING' && _tween.paused()) {
            _tween.play();
          } else if (state !== 'DURING' && !_tween.paused()) {
            _tween.pause();
          }
        } else if (progress != _tween.progress()) { // do we even need to update the progress?
          // no infinite loop - so should we just play or go to a specific point in time?
          if (Scene.duration() === 0) {
            // play the animation
            if (progress > 0) { // play from 0 to 1
              _tween.play();
            } else { // play from 1 to 0
              _tween.reverse();
            }
          } else {
            // go to a specific point in time
            if (Scene.tweenChanges() && _tween.tweenTo) {
              // go smooth
              _tween.tweenTo(progress * _tween.duration());
            } else {
              // just hard set it
              _tween.progress(progress).pause();
            }
          }
        }
      }
    };

    /**
     * Add a tween to the scene.  
     * If you want to add multiple tweens, add them into a GSAP Timeline object and supply it instead (see example below).  
     * 
     * If the scene has a duration, the tween's duration will be projected to the scroll distance of the scene, meaning its progress will be synced to scrollbar movement.  
     * For a scene with a duration of `0`, the tween will be triggered when scrolling forward past the scene's trigger position and reversed, when scrolling back.  
     * To gain better understanding, check out the [Simple Tweening example](../examples/basic/simple_tweening.html).
     *
     * Instead of supplying a tween this method can also be used as a shorthand for `TweenMax.to()` (see example below).
     * @memberof! animation.GSAP#
     *
     * @example
     * // add a single tween directly
     * scene.setTween(TweenMax.to("obj"), 1, {x: 100});
     *
     * // add a single tween via variable
     * var tween = TweenMax.to("obj"), 1, {x: 100};
     * scene.setTween(tween);
     *
     * // add multiple tweens, wrapped in a timeline.
     * var timeline = new TimelineMax();
     * var tween1 = TweenMax.from("obj1", 1, {x: 100});
     * var tween2 = TweenMax.to("obj2", 1, {y: 100});
     * timeline
     *    .add(tween1)
     *    .add(tween2);
     * scene.addTween(timeline);
     *
     * // short hand to add a TweenMax.to() tween
     * scene.setTween("obj3", 0.5, {y: 100});
     *
     * // short hand to add a TweenMax.to() tween for 1 second
     * // this is useful, when the scene has a duration and the tween duration isn't important anyway
     * scene.setTween("obj3", {y: 100});
     *
     * @param {(object|string)} TweenObject - A TweenMax, TweenLite, TimelineMax or TimelineLite object that should be animated in the scene. Can also be a Dom Element or Selector, when using direct tween definition (see examples).
     * @param {(number|object)} duration - A duration for the tween, or tween parameters. If an object containing parameters are supplied, a default duration of 1 will be used.
     * @param {object} params - The parameters for the tween
     * @returns {Scene} Parent object for chaining.
     */
    Scene.setTween = function (TweenObject, duration, params) {
      var newTween;
      if (arguments.length > 1) {
        if (arguments.length < 3) {
          params = duration;
          duration = 1;
        }
        TweenObject = Tween.to(TweenObject, duration, params);
      }
      try {
        // wrap Tween into a Timeline Object if available to include delay and repeats in the duration and standardize methods.
        if (Timeline) {
          newTween = new Timeline({
            smoothChildTiming: true
          }).add(TweenObject);
        } else {
          newTween = TweenObject;
        }
        newTween.pause();
      } catch (e) {
        log(1, "ERROR calling method 'setTween()': Supplied argument is not a valid TweenObject");
        return Scene;
      }
      if (_tween) { // kill old tween?
        Scene.removeTween();
      }
      _tween = newTween;

      // some properties need to be transferred it to the wrapper, otherwise they would get lost.
      if (TweenObject.repeat && TweenObject.repeat() === -1) { // TweenMax or TimelineMax Object?
        _tween.repeat(-1);
        _tween.yoyo(TweenObject.yoyo());
      }
      // Some tween validations and debugging helpers
      if (Scene.tweenChanges() && !_tween.tweenTo) {
        log(2, "WARNING: tweenChanges will only work if the TimelineMax object is available for ScrollMagic.");
      }

      // check if there are position tweens defined for the trigger and warn about it :)
      if (_tween && Scene.controller() && Scene.triggerElement() && Scene.loglevel() >= 2) { // controller is needed to know scroll direction.
        var
          triggerTweens = Tween.getTweensOf(Scene.triggerElement()),
          vertical = Scene.controller().info("vertical");
        triggerTweens.forEach(function (value, index) {
          var
            tweenvars = value.vars.css || value.vars,
            condition = vertical ? (tweenvars.top !== undefined || tweenvars.bottom !== undefined) : (tweenvars.left !== undefined || tweenvars.right !== undefined);
          if (condition) {
            log(2, "WARNING: Tweening the position of the trigger element affects the scene timing and should be avoided!");
            return false;
          }
        });
      }

      // warn about tween overwrites, when an element is tweened multiple times
      if (parseFloat(TweenLite.version) >= 1.14) { // onOverwrite only present since GSAP v1.14.0
        var
          list = _tween.getChildren ? _tween.getChildren(true, true, false) : [_tween],
          // get all nested tween objects
          newCallback = function () {
            log(2, "WARNING: tween was overwritten by another. To learn how to avoid this issue see here: https://github.com/janpaepke/ScrollMagic/wiki/WARNING:-tween-was-overwritten-by-another");
          };
        for (var i = 0, thisTween, oldCallback; i < list.length; i++) {
          thisTween = list[i];
          if (oldCallback !== newCallback) { // if tweens is added more than once
            oldCallback = thisTween.vars.onOverwrite;
            thisTween.vars.onOverwrite = function () {
              if (oldCallback) {
                oldCallback.apply(this, arguments);
              }
              newCallback.apply(this, arguments);
            };
          }
        }
      }
      log(3, "added tween");

      updateTweenProgress();
      return Scene;
    };

    /**
     * Remove the tween from the scene.  
     * This will terminate the control of the Scene over the tween.
     *
     * Using the reset option you can decide if the tween should remain in the current state or be rewound to set the target elements back to the state they were in before the tween was added to the scene.
     * @memberof! animation.GSAP#
     *
     * @example
     * // remove the tween from the scene without resetting it
     * scene.removeTween();
     *
     * // remove the tween from the scene and reset it to initial position
     * scene.removeTween(true);
     *
     * @param {boolean} [reset=false] - If `true` the tween will be reset to its initial values.
     * @returns {Scene} Parent object for chaining.
     */
    Scene.removeTween = function (reset) {
      if (_tween) {
        if (reset) {
          _tween.progress(0).pause();
        }
        _tween.kill();
        _tween = undefined;
        log(3, "removed tween (reset: " + (reset ? "true" : "false") + ")");
      }
      return Scene;
    };

  });
}));

/**
 * @preserve
 * Project: Bootstrap Hover Dropdown
 * Author: Cameron Spear
 * Version: v2.2.1
 * Contributors: Mattia Larentis
 * Dependencies: Bootstrap's Dropdown plugin, jQuery
 * Description: A simple plugin to enable Bootstrap dropdowns to active on hover and provide a nice user experience.
 * License: MIT
 * Homepage: http://cameronspear.com/blog/bootstrap-dropdown-on-hover-plugin/
 */
; (function ($, window, undefined) {
  // outside the scope of the jQuery plugin to
  // keep track of all dropdowns
  var $allDropdowns = $();

  // if instantlyCloseOthers is true, then it will instantly
  // shut other nav items when a new one is hovered over
  $.fn.dropdownHover = function (options) {
    // don't do anything if touch is supported
    // (plugin causes some issues on mobile)
    if ('ontouchstart' in document) return this; // don't want to affect chaining

    // the element we really care about
    // is the dropdown-toggle's parent
    $allDropdowns = $allDropdowns.add(this.parent());

    return this.each(function () {
      var $this = $(this),
        $parent = $this.parent(),
        defaults = {
          delay: 500,
          hoverDelay: 0,
          instantlyCloseOthers: true
        },
        data = {
          delay: $(this).data('delay'),
          hoverDelay: $(this).data('hover-delay'),
          instantlyCloseOthers: $(this).data('close-others')
        },
        showEvent = 'show.bs.dropdown',
        hideEvent = 'hide.bs.dropdown',
        // shownEvent  = 'shown.bs.dropdown',
        // hiddenEvent = 'hidden.bs.dropdown',
        settings = $.extend(true, {}, defaults, options, data),
        timeout, timeoutHover;

      $parent.hover(function (event) {
        // so a neighbor can't open the dropdown
        if (!$parent.hasClass('open') && !$this.is(event.target)) {
          // stop this event, stop executing any code
          // in this callback but continue to propagate
          return true;
        }

        openDropdown(event);
      }, function () {
        // clear timer for hover event
        window.clearTimeout(timeoutHover)
        timeout = window.setTimeout(function () {
          $this.attr('aria-expanded', 'false');
          $parent.removeClass('open');
          $this.trigger(hideEvent);
        }, settings.delay);
      });

      // this helps with button groups!
      $this.hover(function (event) {
        // this helps prevent a double event from firing.
        // see https://github.com/CWSpear/bootstrap-hover-dropdown/issues/55
        if (!$parent.hasClass('open') && !$parent.is(event.target)) {
          // stop this event, stop executing any code
          // in this callback but continue to propagate
          return true;
        }

        openDropdown(event);
      });

      // handle submenus
      $parent.find('.dropdown-submenu').each(function () {
        var $this = $(this);
        var subTimeout;
        $this.hover(function () {
          window.clearTimeout(subTimeout);
          $this.children('.dropdown-menu').show();
          // always close submenu siblings instantly
          $this.siblings().children('.dropdown-menu').hide();
        }, function () {
          var $submenu = $this.children('.dropdown-menu');
          subTimeout = window.setTimeout(function () {
            $submenu.hide();
          }, settings.delay);
        });
      });

      function openDropdown(event) {
        if ($this.parents('.navbar').find('.navbar-toggle').is(':visible')) {
          // If we're inside a navbar, don't do anything when the
          // navbar is collapsed, as it makes the navbar pretty unusable.
          return;
        }

        // clear dropdown timeout here so it doesnt close before it should
        window.clearTimeout(timeout);
        // restart hover timer
        window.clearTimeout(timeoutHover);

        // delay for hover event.  
        timeoutHover = window.setTimeout(function () {
          $allDropdowns.find(':focus').blur();

          if (settings.instantlyCloseOthers === true)
            $allDropdowns.removeClass('open');

          // clear timer for hover event
          window.clearTimeout(timeoutHover);
          $this.attr('aria-expanded', 'true');
          $parent.addClass('open');
          $this.trigger(showEvent);
        }, settings.hoverDelay);
      }
    });
  };
})(jQuery, window);

// https://gist.github.com/kshnurov/8b175b8798d4a907e47b

(function ($) {
  $.fn.photoswipe = function (options) {
    var galleries = [],
      _options = options;

    var init = function ($this) {
      galleries = [];
      $this.each(function (i, gallery) {
        galleries.push({
          id: i,
          items: []
        });

        $(gallery).find('a').each(function (k, link) {
          var $link = $(link),
            size = $link.data('size').split('x');
          if (size.length != 2) {
            throw SyntaxError("Missing data-size attribute.");
          }
          $link.data('gallery-id', i + 1);
          $link.data('photo-id', k);

          var item = {
            src: link.href,
            msrc: link.children[0].getAttribute('src'),
            w: parseInt(size[0], 10),
            h: parseInt(size[1], 10),
            title: $link.data('title'),
            el: link
          }

          galleries[i].items.push(item);

        });

        $(gallery).on('click', 'a', function (e) {
          e.preventDefault();
          var gid = $(this).data('gallery-id'),
            pid = $(this).data('photo-id');
          openGallery(gid, pid);
        });
      });
    }

    var parseHash = function () {
      var hash = window.location.hash.substring(1),
        params = {};

      if (hash.length < 5) {
        return params;
      }

      var vars = hash.split('&');
      for (var i = 0; i < vars.length; i++) {
        if (!vars[i]) {
          continue;
        }
        var pair = vars[i].split('=');
        if (pair.length < 2) {
          continue;
        }
        params[pair[0]] = pair[1];
      }

      if (params.gid) {
        params.gid = parseInt(params.gid, 10);
      }

      if (!params.hasOwnProperty('pid')) {
        return params;
      }
      params.pid = parseInt(params.pid, 10);
      return params;
    };

    var openGallery = function (gid, pid) {
      var pswpElement = document.querySelectorAll('.pswp')[0],
        items = galleries[gid - 1].items,
        options = {
          index: pid,
          galleryUID: gid,
          getThumbBoundsFn: function (index) {
            var thumbnail = items[index].el.children[0],
              pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect();

            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }
        };
      $.extend(options, _options);
      var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
    }

    // initialize
    init(this);

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = parseHash();
    if (hashData.pid > 0 && hashData.gid > 0) {
      openGallery(hashData.gid, hashData.pid);
    }

    return this;
  };
}(jQuery));

/*https://stackoverflow.com/questions/3514784/what-is-the-best-way-to-detect-a-mobile-device-in-jquery*/
function isMobile() {
  var bol = false;
  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) bol = true;
  return bol;
}

// NORMALIZATION: https://www.youtube.com/watch?v=hJqRcExiBk0
// rangeToPercent
function norm(value, min, max) {
  return ((value - min) / (max - min));
}

// LINEAR INTERPOLATION: https://www.youtube.com/watch?v=mAi2-LTC2CA
// percentToRange
function lerp(value, min, max) {
  return ((max - min) * value + min);
}

// MAP: https://www.youtube.com/watch?v=FxAEXHGZSPA
function map(value, sourceMin, sourceMax, destMin, destMax) {
  return lerp(norm(value, sourceMin, sourceMax), destMin, destMax);
}

// CLAMP: https://www.youtube.com/watch?v=A-uIFk_uWdw
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

// PYTHAGOREAN THEOREM AND DISTANCE: https://www.youtube.com/watch?v=L7CApjPVP7c
function distance(firstX, firstY, secondX, secondY) {
  var dx = secondX - firstX,
    dy = secondY - firstY;
  return Math.sqrt(dx * dx + dy * dy);
}

// A BETTER RANDOM: https://www.youtube.com/watch?v=n6rDL8Y6iTA
function randomRange(min, max) {
  return min + Math.random() * (max - min);
}

function randomInt(min, max) {
  return Math.floor(min + Math.random() * (max - min + 1));
}
// ---------------

// RANDOM DISTRIBUTION: https://www.youtube.com/watch?v=_5Z3rD5o3Ic
function randomDist(min, max, iterations) {
  var total = 0;

  for (var i = 0; i < iterations; i += 1) {
    total += utils.randomRange(min, max);
  }

  return total / iterations;
}

// DEGREES AND RADIANS: https://www.youtube.com/watch?v=MHoFqRyeP3o
function degreesToRads(degrees) {
  return degrees / 180 * Math.PI;
}

function radsToDegrees(radians) {
  return radians * 180 / Math.PI;
}
// ---------------

// ROUDING: https://www.youtube.com/watch?v=s0IhSEmnZCU
function roundToPlaces(value, places) {
  var mult = Math.pow(10, places);
  return Math.round(value * mult) / mult;
}

function roundToNearest(value, nearest) {
  return Math.round(value / nearest) * nearest;
}
// ---------------


/*!
 * jQuery bootstrap 3 breakpoint check
 * Check the current visibility of bootstrap 3 breakpoints
 *
 * @example `$.isXs()` function alias for `$.isBreakpoint("xs")`
 * @example `$.isSm()` function alias for `$.isBreakpoint("sm")`
 * @example `$.isMd()` function alias for `$.isBreakpoint("md")`
 * @example `$.isLg()` function alias for `$.isBreakpoint("lg")`
 * @version 1.0.0
 * @copyright Jens A. (cakebake) and other contributors
 * @license Released under the MIT license
 */

; (function ($) {

  /**
   * Base function to check the current visibility of an bootstrap 3 breakpoint
   *
   * @param {string} breakPoint Something like xs|sm|md|lg
   * @returns {boolean}
   */
  $.isBreakpoint = function (breakPoint) {
    var element, erg;

    element = $("<div/>", {
      "class": "visible-" + breakPoint
    }).appendTo("body");

    erg = element.is(":visible");
    element.remove();

    return erg
  };

  $.extend($, {

    /**
     * Check the current visibility of bootstrap 3 "xs" breakpoint
     * Shorthand function alias for $.isBreakpoint("xs")
     *
     * @returns {boolean}
     */
    isXs: function () {
      return $.isBreakpoint("xs")
    },

    /**
     * Check the current visibility of bootstrap 3 "sm" breakpoint
     * Shorthand function alias for $.isBreakpoint("sm")
     *
     * @returns {boolean}
     */
    isSm: function () {
      return $.isBreakpoint("sm")
    },

    /**
     * Check the current visibility of bootstrap 3 "md" breakpoint
     * Shorthand function alias for $.isBreakpoint("md")
     *
     * @returns {boolean}
     */
    isMd: function () {
      return $.isBreakpoint("md")
    },

    /**
     * Check the current visibility of bootstrap 3 "lg" breakpoint
     * Shorthand function alias for $.isBreakpoint("lg")
     *
     * @returns {boolean}
     */
    isLg: function () {
      return $.isBreakpoint("lg")
    }

  });

})(jQuery);

/* ------------------------- https://maps.googleapis.com/maps/api/js ------------------------- */



/* jshint ignore:end */